import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api';

export interface Account {
  plan: { id: string; name: string; source: string; until: string | null };
  usage: { usedSession: number; usedWeek: number; sessionLimit: number | null; weeklyLimit: number | null; purchased: number; remaining: number | null; used30d: number; sessionRefillAt: string | null };
  blocked: boolean; approved: boolean;
  agreement: { required: boolean; accepted: boolean; version: string };
  admin: { eligible: boolean; isRoot: boolean; active: boolean; needsGoogle: boolean };
  payments: { enabled: boolean; message: string };
  usageCreditsForChat: boolean;
}

export function useAccount(enabled = true) {
  return useQuery({ queryKey: ['account'], queryFn: () => api<Account>('/api/account'), enabled, staleTime: 2_000, refetchInterval: 5_000, refetchIntervalInBackground: false });
}
